import React, { useState } from 'react';
import { TextInput } from 'react-native-paper';
import Icon from 'react-native-vector-icons/Feather';

import { TestId } from '../../constants/test-id';
import { fs } from '../../style-utils';
import { OETextInput, OETextInputProps } from '../oe-text-input/oe-text-input';

export const OETextInputSecure = ({
  testID = TestId.TEXT_INPUT_SECURED,
  ...props
}: OETextInputProps) => {
  const [hideChar, setHideChar] = useState(true);

  const rightComponent = (
    <TextInput.Icon
      name={() => (
        <Icon
          style={fs(16)}
          name={hideChar ? 'eye' : 'eye-off'}
          onPress={() => setHideChar(!hideChar)}
        />
      )}
    />
  );

  return (
    <OETextInput
      {...props}
      testID={testID}
      autoComplete="password"
      textContentType="password"
      secureTextEntry={hideChar}
      right={rightComponent}
    />
  );
};
